module.exports = __webpack_public_path__ + "img/104091.87c418df.png";